import { Pipe, PipeTransform } from '@angular/core';
import { DashInsteadOfNullPipe } from './dash-instead-of-null.pipe';

/**
 * Should be used to transform text with line brakes from text area to
 * the text in <div> using [innerHTML]
 */
@Pipe({
  standalone: true,
  name: 'linkShort',
})
export class LinkShortPipe implements PipeTransform {

  transform(link: string, count: number, withDots = true, withDash = false): string { // use count = -1 to disable pipe transform
    if (!link) {
      if (withDash) {
        return new DashInsteadOfNullPipe().transform(link);
      }
      return;
    }
    if (count === -1) return link;
    if (link.length > count) return link.substring(0, count) + (withDots ? '...' : '');
    return link;
  }

}

